export const BRAND_NAME = 'Rudra555online';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'rudra555.online';
export const PROVIDER_ID = 'BetFair';
